import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
        path: '/',
        name: 'home',
        component: () => import('./views/Form.vue')
    },
    // {
    //     path: '/form2',
    //     name: 'form2',
    //     component: () => import('./views/Form2.vue')
    // },
    {
        path: '*',
        name: '404',
        component: () => import('./views/404.vue')
    }
  ]
})
